import React, { createContext, useContext, useState, useEffect } from 'react';
import { getStorageItem, setStorageItem } from '../utility';
import { STRING_CONSTANTS } from '../constants/common';

const LanguageContext = createContext();

const STORAGE_KEY = 'app_language';

// Get translations from common constants file
const translations = STRING_CONSTANTS.TRANSLATIONS;

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    try {
      const savedLanguage = getStorageItem(STORAGE_KEY);
      return savedLanguage || 'en';
    } catch (error) {
      console.error('Error loading language preference:', error);
      return 'en';
    }
  });

  const [isRTL, setIsRTL] = useState(() => {
    try {
      const savedLanguage = getStorageItem(STORAGE_KEY);
      return savedLanguage === 'ar';
    } catch (error) {
      return false;
    }
  });

  useEffect(() => {
    try {
      setIsRTL(language === 'ar');
      setStorageItem(STORAGE_KEY, language);
      
      // Update document direction and language
      document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
      document.documentElement.lang = language;
    } catch (error) {
      console.error('Error setting language:', error);
    }
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  const t = (key) => {
    return translations[language]?.[key] || translations.en?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, isRTL, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    // Return default values instead of throwing to prevent multiple error messages
    console.warn('useLanguage must be used within a LanguageProvider. Using default values.');
    return {
      language: 'en',
      changeLanguage: () => {},
      isRTL: false,
      t: (key) => key,
    };
  }
  return context;
};

